import { useCallback, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { getAttribution } from "../lib/attribution";
import { track } from "../lib/analytics";

const SID_KEY = "unq_assistant_sid";
const sid = () => {
  let v = sessionStorage.getItem(SID_KEY);
  if (!v) { v = crypto.randomUUID(); sessionStorage.setItem(SID_KEY, v); }
  return v;
};

const GREETING = { role: "assistant", text: "Hi, I'm Nest — Bryan's apartment-locating assistant. Tell me the area, budget and bedrooms you have in mind and I'll help you narrow it down. It's free for renters." };

export const useAssistant = () => {
  const [messages, setMessages] = useState([GREETING]);
  const [loading, setLoading] = useState(false);
  const [suggestLead, setSuggestLead] = useState(false);
  const [leadDone, setLeadDone] = useState(false);
  const [error, setError] = useState(null);

  const send = useCallback(async (text) => {
    const msg = text.trim();
    if (!msg || loading) return;
    setError(null);
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/assistant/chat`, { session_id: sid(), message: msg, page: window.location.pathname });
      setMessages((m) => [...m, { role: "assistant", text: data.reply }]);
      if (data.suggest_lead_capture && !leadDone) setSuggestLead(true);
      track("assistant_message", { page: window.location.pathname });
    } catch (e) {
      setError(e.response?.data?.detail?.message || e.response?.data?.detail || "Nest is briefly unavailable — please try again.");
    } finally {
      setLoading(false);
    }
  }, [loading, leadDone]);

  const submitLead = useCallback(async ({ name, email, phone }) => {
    const summary = messages.filter((m) => m.role === "user").slice(-4).map((m) => m.text).join(" | ");
    const { data } = await axios.post(`${API}/leads`, {
      name, email: email.trim().toLowerCase(), phone: phone || null, lead_type: "renter", source: "ai_assistant",
      message: `Nest chat: ${summary}`.slice(0, 1000), ...getAttribution(),
    });
    await axios.post(`${API}/assistant/link-lead`, { session_id: sid(), lead_id: data.id });
    track("lead_submitted", { source: "ai_assistant", has_phone: !!phone });
    setLeadDone(true); setSuggestLead(false);
    setMessages((m) => [...m, { role: "assistant", text: `Thanks ${name.split(" ")[0]} — Bryan will send your shortlist shortly. Keep chatting if you'd like to refine it.` }]);
  }, [messages]);

  return { messages, loading, error, suggestLead, leadDone, send, submitLead, dismissLead: () => setSuggestLead(false) };
};
